import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { NgForm, NgModel } from '@angular/forms';
import { LocalStorageService } from "ng2-webstorage";
import { NoticeboardService } from "../../../../../components/noticeboard/noticeboard/noticeboard.service";
import { DataAnalyticsService } from "../../../../../components/dataAnalytics/dataAnalytics.service";
import { initGoogleClient } from "../../../../../shared/googleAuth/googleAuthentication";
import { MessageService } from "primeng/components/common/messageservice";
import { ApprovalClassModel } from "../../../../../components/googleClassroom/googleClassroom.model";
import { AddStudentRcModel ,rciModel} from "../../../../../components/dataAnalytics/dataAnalytics.model";
import { AppConstants } from "../../../../../app.constants";
import * as html2pdf from "html2pdf.js"
import { Router } from "@angular/router";
import { style } from "@angular/core/src/animation/dsl";
declare var gapi: any

@Component({
  selector: 'digital-report-card-bulk-upload',
  templateUrl: 'digital-report-card-bulk-upload.component.html',
  styleUrls: ['digital-report-card-bulk-upload.component.scss'],

})
export class DigitalReportCardBulkUploadSComponent implements OnInit {
  public SchoolYear: any;
  Semester: any[];
  Exam: any[];
  public selectedYear: any;
  public selectedsemester: any;
  public selectedExam: any;
  public ShowLevelData: any;
  public selectedlevel: string = "";
  public section: any;
  public selectedgrade: any;
  public selectedTeacher: any;
  public selectedsection: any;
  public grade: any = [];
  selectedSubject: any;
  subjects: any = [];
  academicYearId: any = [];
  SemesterId: any = [];
  subjectsList: any = [];
  public mappedData: any;
  nameofsec: any = [];
  sectionId: any = [];
  sectionList: any = [];
  semesterList: any = [];
  public selectAll: boolean = true;
  selectedSubjects: any = [];



  public TeacherDetailsData: any = [];
  public display;
  public schoolId: any;
  public selectedsub: any;
  public selectedsec: any;

  public selectedTitle: any;
  public enteredFirstName: string;
  public enteredLastName: string;
  public enteredMiddleName: string;
  public enteredEmail: string;
  public enteredPhone: string;

  @ViewChild('form') form: NgForm;


  constructor(
    private dataAnalyticsService: DataAnalyticsService,
    private localStorage: LocalStorageService,
    private messageService: MessageService
  ) {
    this.schoolId = this.localStorage.retrieve("schoolid");
    //this.userId = this.localStorage.retrieve('CurrentChildId');
  }
  ngOnInit() {
    this.getAcademicYear();
  }


  getSelectedSubjectIds(): number[] {
    return Object.keys(this.selectedSubjects).filter(key => this.selectedSubjects[key]).map(Number);
  }



  private getAcademicYear() {
    this.dataAnalyticsService
      .getAcadamicYearOfyears()
      .finally(() => {})
      .subscribe(
        (response) => {
          this.SchoolYear = response["yearList"];
          this.SchoolYear.sort((a, b) => b.AcademicYear.localeCompare(a.AcademicYear));

          console.log("SchoolYear", this.SchoolYear);
          try {
            this.selectedYear = this.SchoolYear[0].YearId;
            console.log(this.selectedYear);
            this.getLevelsName();
          } catch (error) {}
        },
        (error) => {
          this.SchoolYear = [];
          console.error(error);
        }
      );
  }

  changeYear() {
    console.log("selectedYear", this.selectedYear);
  }

  //------------------LEVEL Primary, secondary----------------------------------------------------------------

  private getLevelsName() {
    this.dataAnalyticsService
      .getLevel()
      ._finally(() => {})
      .subscribe(
        (response) => {
          this.ShowLevelData = response;
          try {
            this.selectedlevel = this.ShowLevelData[0].Id;
            // console.log(this.selectedlevel);

            //this.getClassSection(this.selectedlevel["Id"]);
            this.getLevelClassSection(this.selectedlevel);
          } catch (error) {}
          console.log("ShowLevelData", this.ShowLevelData);
        },
        (error) => {}
      );
  }

  getLevelsListById() {
    console.log("selectedlevel", this.selectedlevel);
    this.getLevelClassSection(this.selectedlevel);
  }

  //------------------------Ex Grade 1,2,3, & A,B,C--------------------------------------------------------------

  private getLevelClassSection(lid) {
    this.dataAnalyticsService.GetLevelStandardSectionMapping(lid).finally(() => { }).subscribe(
      response => {
        console.log(response);
        let mappedData: any = response;
        mappedData.forEach(standard => {
          standard['Sections'].forEach(section => {
            section['StdId'] = standard['standardId'];
            section['StdName'] = standard['standardsName'];
            section['selected'] = false;
          });
        });
        console.log("mappedData", mappedData);
        mappedData.sort((a, b) => ("" + a.standardsName).localeCompare(b.standardsName, undefined, { numeric: true }));
        if (true) {
          this.mappedData = mappedData;

        }

        try {
          this.selectedgrade = mappedData[mappedData.length - 1];
          // console.log(this.selectedgrade);
          this.getSectionByGrade(this.selectedgrade);
          this.selectedsection = this.selectedgrade.Sections[0];
          this.getSubjects();
        } catch (error) {
          //window.location.reload();
        }

        try {
          this.nameofsec = this.selectedsection.sectionName;
          this.sectionId = this.selectedsection.SectionId;
        } catch (error) {

        }


      },
      error => {
        this.mappedData = [];
        this.sectionList = [];
        this.subjectsList = [];
        this.selectedgrade = null;
        this.selectedsection = null;
        this.selectedSubject = null;
      });
  };

  getSectionByGrade(grade) {
    this.subjectsList = [];
    this.selectedSubject = null;
    this.sectionList = grade.Sections;
    try {
      this.selectedsection = this.sectionList[0];
      // console.log(this.selectedsection);
      this.getSubjects();
    } catch (error) {

    }
  }

  getGclClassesListById(section) {

    this.nameofsec = section.sectionName;
    this.sectionId = section.SectionId;
    //this.getStudentData(this.standardId,section.SectionId,this.yearId)
    this.selectedsec = section.SectionId
    // console.log('getGclClassesListById', this.selectedsec);

    this.getSubjects();
    this.getSemesters();

  }
  /* -----------------------------GET SUBJECT--------------------------------*/

  getSubjects() {
    this.dataAnalyticsService
      .getSubjects(this.selectedsection.SectionId)
      .finally(() => {})
      .subscribe(
        (response) => {
          let res: any = response;
          console.log("getSubjects", res);
          this.subjectsList = res.subsemList[0];
          this.Semester = res.subsemList[1];
          this.selectedSubject = this.subjectsList[0];
          this.selectedsemester = this.Semester[0];
          console.log(this.subjectsList);
          // console.log(this.selectedSubject);
          // console.log(this.selectedsemester);
          // this.getExams();


        },

        (error) => {
          console.log("getSubjects error", error);
          this.subjectsList = [];
        }
      );
  }


  onSelectedSubject(subject) {
    this.getSemesters();
    // this.getExams();
    this.selectedsub = subject.SubjectId;
    console.log("onSelectedSubject", this.selectedsub);
  }

  /* -----------------------------GET SEMESTERS--------------------------------*/

  getSemesters() {
    this.dataAnalyticsService
      .getSemesterT(this.selectedYear)
      .finally(() => {})
      .subscribe(
        (response) => {
          this.Semester = response["semestersList"];
          // console.log("semester", this.Semester);
          try {
            this.selectedsemester = this.Semester[0].SemesterId;
          } catch (error) {}
        },
        (error) => {
          this.Semester = [];
          console.error(error);
        }
      );
  }

  onSelectedSemesters() {
    console.log("selectedsemester", this.selectedsemester);
    this.getExams();
  }

  /* -----------------------------GET EXAMS--------------------------------*/

  getExams() {
    console.log(this.selectedsemester);
    this.dataAnalyticsService
      .getTestT(this.selectedsemester)
      .finally(() => {})
      .subscribe(
        (response) => {
          this.Exam = response["testsList"];
          console.log("Exam", this.Exam);
          console.log("SemesterId", this.SemesterId);
          try {

            this.selectedExam = this.Exam[0].TestId;
          } catch (error) {}
        },
        (error) => {
          this.Exam = [];
          console.error(error);
        }
      );
  }

  onSelectedExams() {
    console.log("selectedExam", this.selectedExam);
  }

  /*------------------------------------------------------------------------------------------------------------------*/

  PostSubjectTestMapping() {
    this.selectedSubjects = this.subjectsList.map(subject => subject.SubjectId);
    var payload = {
      AcademicYearId: this.selectedYear,
      // SectionId: this.selectedsec,
      SectionId: this.selectedsection.SectionId,
      SemesterId: this.selectedsemester,
      // SubjectId: this.selectedsub,
      SubjectIds: this.selectedSubjects,
      TestId: this.selectedExam,
    };

    console.log(payload);


    // console.log("PostSubjectTestMapping", payload);

    this.dataAnalyticsService
      .PostSubjectTestMapping(payload)
      .finally(() => {})
      .subscribe(
        (response) => {
          this.messageService.add({
            severity: "success",
            summary: "Talkative Parents",
            detail: " Add Subject To Exam Successfully",
          });
          this.ngOnInit();
          this.form.reset();
          this.selectedSubjects = [];
          this.display = "none";
          //this.getHigherEdChildBatch();
          this.selectedSubjects = [];
          console.log(response);
        },
        (error) => {}
      );
  }
}



// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/dashboard/pages/course/digital-report-card-bulk-upload-s/digital-report-card-bulk-upload.component.ts